export const SNACKBAR_OPEN = 'SNACKBAR_OPEN'
export const SNACKBAR_CLOSE = 'SNACKBAR_CLOSE'



// WEBPACK FOOTER //
// ./src/types/actions/snack-bar.js